import React, { useContext, useEffect } from 'react'
import { PageTitle } from '../../layout/core'
import { Navigate, Route, Routes, Outlet } from 'react-router-dom'
import AllBots from './AllBots'
import AiSeletectedBot from './AiSeletectedBot'
import InstallBot from './components/InstallBot'

const AIBotsPage: React.FC = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='/all-bots'
          element={
            <>
              <PageTitle breadcrumbs={[]}>All Bots</PageTitle>
              <AllBots />
            </>
          }
        />

        <Route
          path='/ai-bot-builder/:uuid'
          element={
            <>
              <PageTitle breadcrumbs={[]}>Bot</PageTitle>
              <AiSeletectedBot />
            </>
          }
        />
        <Route
          path='/ai-bot-builder/install-bot/:appId'
          element={
            <>
              <PageTitle breadcrumbs={[]}>Install Bot</PageTitle>
              <InstallBot />
            </>
          }
        />
        <Route index element={<Navigate to='/ai-bots/all-bots' />} />
      </Route>
    </Routes>
  )
}

export default AIBotsPage
